// extracted by extract-css-chunks-webpack-plugin
module.exports = {"switchRecipient":"switchRecipient__switchRecipient","btnSwitch":"switchRecipient__btnSwitch","accName":"switchRecipient__accName"};